// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiurl: (window as any).__pros_env?.authUrl || 'url not found !',
  bannerBroadcastJsonUrl: 'https://d118pdohiuwf5u.cloudfront.net/communications/1.0/banner.json'
};
